<template>
  <div>
    <WdsText secondary class="tw-mb-1">{{ header }}</WdsText>
    <div class="code-wrapper">
      <pre>{{ content }}</pre>
      <button v-if="content" class="copy-button" @click="copy(content)">
        <WdsIcon :size="16" :name="copied ? 'checkmark' : 'copy'" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { WdsIcon, WdsText } from '@worksome/wds-components'

const props = defineProps({
  header: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    required: true,
  },
})

const { copy, copied } = useClipboard()
</script>

<style scoped lang="scss">
.code-wrapper {
  position: relative;
}

.code-wrapper .copy-button {
  background: transparent;
  position: absolute;
  opacity: 0.25;
  border: none;
  right: 0.05rem;
  top: 0.25rem;
  transition: opacity 0.3s;
}

.code-wrapper .copy-button:hover {
  opacity: 1;
}

.code-wrapper pre {
  font-size: smaller;
}
</style>
